<template>
  <div>
    <template v-if="collegeHasCrisisPhoneFeature">
      <p
        class="mt-2 mb-4"
        style="color: rgba(255,255,255,0.67);"
      >
        BetterMynd's video-based teletherapy services are not designed
        to be used by students in active crisis. However,
        if you are a student in need of immediate support
        or crisis support, please use the 24/7 On-Demand
        Emotional Support and Crisis Line number below to
        connect with a clinician who can provide immediate support.
      </p>
      <div class="row mt-4">
        <div class="col-12">
          <b>BetterMynd Crisis Hotline:</b>
        </div>
        <div class="col-12">
          <a :href="college.betterMyndCrisisPhoneHref">
            {{ college.bettermynd_crisis_phone }}
          </a>
          <a :href="college.betterMyndCrisisPhoneHref">
            ({{ college.betterMyndCrisisNumericPhone }})
          </a>
        </div>
      </div>
    </template>

    <template v-else>
      <p
        class="mt-2 mb-4"
        style="color: rgba(255,255,255,0.67);"
      >
        BetterMynd is not a crisis resource and should not be 
        used by anyone experiencing a life-threatening or emergency 
        situation. If you are in crisis, you should call 911 or use 
        one of the below resources to access immediate help, 24/7.
      </p>
      <div class="row mt-4">
        <div class="col-12">
          <b>National Mental Health Emergency Hotline:</b>
        </div>
        <div class="col-12">
          <a href="tel:988">988</a>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <b>Crisis Text Line </b>
        </div>
        <div class="col-12">
          <a href="sms:741741?body=HOME."> Text HOME to 741741</a>
        </div>
      </div>
    </template>

    <div v-if="college && college.campus_crisis_info" class="row mt-4">
      <div class="col-12">
        <b>On-Campus Crisis Resources</b>
      </div>
      <div class="col-12">
        <p
          style="white-space: normal"
          v-html="college.campus_crisis_info"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'CrisisBlurb',
  props: {
    collegeHasCrisisPhoneFeature: {
      type: Boolean,
      required: true,
    },
    college: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
label {
  @include label;

  display: inline-block;
  margin-bottom: 15px;
}
</style>
